"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var kendo_react_common_1 = require("@progress/kendo-react-common");
/**
 * @hidden
 */
var DOMService = /** @class */ (function () {
    function DOMService() {
        this.didCalculate = false;
    }
    DOMService.prototype.ensureHeights = function () {
        if (this.timeListHeight !== undefined) {
            return;
        }
        this.calculateHeights();
    };
    DOMService.prototype.calculateHeights = function (container) {
        if (!kendo_react_common_1.canUseDOM) {
            return;
        }
        var div = utils_1.domContainerFactory('div');
        var ul = utils_1.domContainerFactory('ul');
        var li = utils_1.domContainerFactory('li');
        var listItem = function () { return li('<span>02</span>', 'k-item'); };
        var list = function () { return ul([listItem()], 'k-reset'); };
        var scrollable = function () { return (div([list()], 'k-time-container k-content k-scrollable')); };
        var timeListWrapper = function () {
            return div([div([scrollable()], 'k-time-list')], 'k-time-list-wrapper', { left: '-10000px', position: 'absolute' });
        };
        var timeWrapper = timeListWrapper();
        var listContainer = container && container.querySelector('.k-time-container');
        var hostContainer = listContainer || document.body;
        var wrapper = hostContainer.appendChild(timeWrapper);
        this.timeListHeight = wrapper.querySelector('.k-scrollable').offsetHeight;
        this.itemHeight = wrapper.querySelector('li').offsetHeight;
        hostContainer.removeChild(wrapper);
        this.didCalculate = true;
    };
    return DOMService;
}());
exports.DOMService = DOMService;
//# sourceMappingURL=DOMService.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-dateinputs@3.18.0_@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_r_2yelhkp6sdgaltctm3m4k3bqy4/~/@progress/kendo-react-dateinputs/dist/npm/timepicker/services/DOMService.js
// module id = 6524
// module chunks = 0